import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorOptionsGroupHeading = ({
  children,
  spaceStyleProps
}) => {
  return /*#__PURE__*/_jsx(Text, Object.assign({
    as: "h6",
    marginBlockEnd: "200",
    textTransform: "none"
  }, spaceStyleProps, {
    children: children
  }));
};
export default EditorOptionsGroupHeading;